<template>
  <div class="contentHome">
    <div class="centerPage">
      <tabCommon></tabCommon>
      <div class="right">
        <div class="title flex">
          <span>我的优惠券</span>
          <div class="btnTab">
            <el-button size="mini" @click="changeStatus(0,0)" :class="active==0?'activeIndex':''">待使用({{ count.all }})
            </el-button>
            <el-button size="mini" @click="changeStatus(1,1)" :class="active==1?'activeIndex':''">优惠券({{
                count.coupon
              }})
            </el-button>
            <el-button size="mini" @click="changeStatus(2,2)" :class="active==2?'activeIndex':''">月卡({{ count.month }})
            </el-button>
            <el-button size="mini" @click="changeStatus(3,3)" :class="active==3?'activeIndex':''">年卡({{ count.annual }})
            </el-button>
            <el-button size="mini" @click="changeStatus(4,4)" :class="active==4?'activeIndex':''">
              已失效
            </el-button>
          </div>
        </div>
        <div class="formUserInfo">

          <div class="couponsList">
            <div v-for="(obj,ind) in page.rows" :key="ind">
              <h3 class="doctorCommon">
                {{ obj[0].doctorFullName }}
                {{ obj[0].doctorEnName }}
                ({{ obj.length }})
              </h3>
              <div class="coupons"
                   v-for="(item,index) in obj"
                   :key="index"
                   :class="{'special':item.couponType == 2|| item.couponType == 3,'unavailable':active==4}">
                <div class="borderCou">
                  <template v-if="item.couponType == 1">
                    <div class="discount">{{ item|couponDiscountFmt }}<span v-if="item.discountMode == 1">折</span></div>
                    <p class="fullReductionAmount" v-if="item.fullReductionAmount>0">满{{
                        item.fullReductionAmount / 100
                      }}元可用</p>
                    <p class="stackable"> {{ (item.stackable == 0 ? '不' : '') + '可叠加' }}</p>
                  </template>
                  <template v-else>
                    <div class="discount">{{ item.couponType == 2 ? '月卡' : '年卡' }}</div>
                    <p class="useLimitCount">可用{{ item.limitUseCount }}次</p>
                  </template>
                  <div class="time">有效期至：{{ new Date(item.limitEndDate).Format('yyyy/MM/dd') }}</div>
                </div>
                <span class="op-gain" v-if="active == 4">已失效</span>
                <span class="op-gain" style="cursor: pointer" v-else
                      @click="$router.push({path: '/' + item.doctorAccount})">去使用</span>
              </div>
              <div style="clear: both"></div>
            </div>
            <div class="empty" v-if="JSON.stringify(page.rows)==='{}'">
              <img src="../../assets/img/no.png" alt="" height="204">
              <p>这里什么都没有</p>
            </div>
          </div>
          <el-pagination
              v-if="active==4"
              class="pagination"
              background
              prev-text="Prev"
              next-text="Next"
              @current-change="skipPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next"
              :total="page.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import base from "@/api/common";

export default {
  name: "mineCoupon",
  data() {
    return {
      active: 0,
      count: {
        all: 0,
        coupon: 0,
        month: 0,
        annual: 0
      },
      page: {
        rows: {},
        type: 0,
        current: 1,
        size: 10,
        total: 0,
      }
    }
  },
  components: {
    'tabCommon': () => import('./tabCommon'),
  },
  mounted() {
    this.$ajax.get(base.api.coupon.statistics).then((res) => {
      if (res.data.status === 'success') {
        if (res.data.data) {
          this.count.coupon = res.data.data.coupon;
          this.count.month = res.data.data.month;
          this.count.annual = res.data.data.annual;
        }
        this.getData();
      }
    });
  },
  filters: {
    couponDiscountFmt(item) {
      if (item.discountMode == 1) { //折扣
        return item.discountRate / 10;
      } else if (item.discountMode == 2) { //定额
        return '￥' + item.discountAmount / 100;
      }
      return '0';
    }
  },
  methods: {
    // 可用优惠券
    getData() {
      let that = this;
      that.$ajax.post(base.api.coupon.available, {couponType: Number(this.page.type)}).then(res => {
        if (res.data.status === 'success') {
          let data = res.data.list
          let map = new Map()
          data.forEach(o => {
            if (map.get(o.doctorId)) {
              map.get(o.doctorId).list.push(o)
            } else {
              map.set(o.doctorId, {list: []})
              map.get(o.doctorId).list.push(o)
            }
          })
          let object = new Object();
          map.forEach((v, k) => {
            object[k] = v.list;
          });
          this.page.rows = object;

          if (this.active == 0) {
            this.count.all = res.data.list.length
          }
        }
      })
    },
    // 失效优惠券
    getUnavailable() {
      let that = this;
      let condition = {
        page: that.page.current,
        size: that.page.size,
      };
      that.$ajax.post(base.api.coupon.unavailable, condition).then(res => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          let data = res.data.rows
          let map = new Map()
          data.forEach(o => {
            if (map.get(o.doctorId)) {
              map.get(o.doctorId).list.push(o)
            } else {
              map.set(o.doctorId, {list: []})
              map.get(o.doctorId).list.push(o)
            }
          })
          let object = new Object();
          map.forEach((v, k) => {
            object[k] = v.list;
          });
          this.page.rows = object;
        }
      })
    },
    changeStatus(index, type) {
      this.active = index;
      this.page.type = type;
      this.page.rows = []
      if (type == 4) {
        this.getUnavailable()
      } else {
        this.getData();
      }
    },
    skipPage(cur) {
      this.page.current = cur;
      this.page.rows = []
      this.getUnavailable();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.cnHomeTabsItem {
  .avatar {
    width: 150px;
    height: 75px;
  }

  .rightHome {
    width: calc(100% - 170px);
  }
}

</style>
